import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NewLead from "../wizards/Lead/NewLead";

const Layout = () => {
  return (
    <>
      <Navbar />
      <main className="position-absolute top-0 " style={{
      overflow: 'hidden',
      width: '100vw',
    }}>
        <Outlet />
        <Footer />
        <NewLead/>
      </main>
    </>
  );
};

export default Layout;
